import React from 'react';
import { InView } from 'react-intersection-observer';
import { useViewEvent } from '@stitch-fix/event-reporter';
import Box from '../Box';
import CategoryCardBase, {
  CategoryCardBaseProps,
} from '../CategoryCard/CategoryCardBase';
import IconArrowRight16 from '../icons/IconArrowRight16';
import { IconMore32 } from '../icons';
import Link from '../Link';
import Stack from '../Stack';

type CarouselEndCard = {
  cta: NonNullable<CategoryCardBaseProps['cta']>;
  linkAs?: CategoryCardBaseProps['linkAs'];
};

export type EndCardProps = {
  categorySetId: string;
  endCard: CarouselEndCard;
  onClick?: () => void;
  onView?: () => void;
  variant: CategoryCardBaseProps['variant'];
};

const EndCard = ({
  categorySetId,
  endCard,
  onClick,
  onView,
  variant,
}: EndCardProps) => {
  const { ref, EventProvider, reportSelectEvent } = useViewEvent({
    schema: 'category_set_view',
    category_set_id: categorySetId,
    name: 'view_all_end_card',
  });

  const handleClick = () => {
    reportSelectEvent({
      schema: 'category_set_select',
      action_name: 'navigate_to_category_set',
      category_set_id: categorySetId,
      name: 'view_all_end_card',
    });
    onClick?.();
  };

  return (
    <EventProvider>
      <InView
        key="end-card"
        data-testid="category-end-card-observer-wrapper"
        onChange={inView => {
          if (inView) onView?.();
        }}
        triggerOnce
      >
        <CategoryCardBase
          ref={ref}
          href={endCard.cta.href}
          image={
            <Box
              bgColor="mint-60"
              color="blue-45"
              height="100%"
              display="flex"
              style={{
                justifyContent: 'center',
                flexDirection: 'column',
              }}
            >
              <Stack hAlign="center" spacing={0}>
                <IconMore32
                  color="blue-45"
                  width="40"
                  height="40"
                  purpose="decorative"
                />

                {variant !== 'icon' && (
                  <Link
                    as="div"
                    size="tertiary"
                    variant="inherit"
                    endIcon={<IconArrowRight16 />}
                    mt={0.5}
                  >
                    {endCard.cta.text}
                  </Link>
                )}
              </Stack>
            </Box>
          }
          linkAs={endCard.linkAs}
          onClick={handleClick}
          title={variant === 'icon' ? endCard.cta.text : ''}
          variant={variant}
        />
      </InView>
    </EventProvider>
  );
};

export default EndCard;
